"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PropTypes = __importStar(require("prop-types"));
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const redux_saga_1 = require("redux-saga");
const recompose_1 = require("recompose");
//import { View, Text } from "react-native";
const PRODUCT = "∏";
function unshift(a) {
    const path = a[PRODUCT];
    if (path != null) {
        return [
            Object.assign({}, a, { 
                // path.length <= 1 means "if path will be empty, treat it as having no path"
                [PRODUCT]: !path || path.length <= 1 ? undefined : path.slice(1) }),
            path[0]
        ];
    }
    return [a, undefined];
}
const keyed = (key, reducer) => {
    return (s, a) => {
        const path = a[PRODUCT];
        if (path == null || path[0] === key) {
            return reducer(s, Object.assign({}, a, { 
                // path.length <= 1 means "if path will be empty, treat it as having no path"
                [PRODUCT]: !path || path.length <= 1 ? undefined : path.slice(1) }));
        }
        return s !== undefined ? s : reducer(s, a);
    };
};
exports.keyed = keyed;
const combineKeyedReducers = (reducers) => {
    const keyedReducers = {};
    Object.keys(reducers).forEach(key => (keyedReducers[key] = keyed(key, reducers[key])));
    return redux_1.combineReducers(keyedReducers);
};
exports.combineKeyedReducers = combineKeyedReducers;
const dynamicKey = (reducer) => (s, a) => {
    const [action, key] = unshift(a);
    if (key != null) {
        //  console.log("dynamicKey", s, a);
        const oldState = s[key];
        const newState = reducer(oldState, action);
        if (newState !== oldState) {
            return Object.assign({}, s, { [key]: newState });
        }
    }
    return s;
};
exports.dynamicKey = dynamicKey;
const KeyedProjection = (key) => {
    const saga = (saga) => {
        var _a;
        return recompose_1.pure((_a = class Saga extends React.Component {
                componentDidMount() {
                    this.runSaga(this.props);
                }
                componentWillUnmount() {
                    console.log("will unmount, cancelling saga");
                    if (this.sagaTask != null) {
                        this.sagaTask.cancel();
                    }
                }
                runSaga(props) {
                    console.log("starting saga", saga.name, props);
                    this.sagaTask = this.context[key].runSaga(saga, props);
                }
                componentWillReceiveProps(props) {
                    console.log("new props, restarting saga", props, this.props, props != this.props);
                    if (this.sagaTask != null) {
                        this.sagaTask.cancel();
                    }
                    this.runSaga(props);
                }
                render() {
                    return null;
                }
            },
            _a.contextTypes = {
                [key]: PropTypes.object
            },
            _a));
    };
    class Projection extends React.Component {
        constructor(props) {
            super(props);
            this.getState = this.getState.bind(this);
            this.subscribe = this.subscribe.bind(this);
            this.dispatch = this.dispatch.bind(this);
            this.sagas = new Set();
            //      console.log("Projection", key, this);
        }
        getChildContext() {
            return {
                [key]: this
            };
        }
        getStore() {
            return this.context[key] || this.context.store;
        }
        getState() {
            const s = this.getStore().getState();
            return s[this.props.ns];
        }
        subscribe(fn) {
            return this.getStore().subscribe(fn);
        }
        dispatch(action) {
            const keyedAction = Object.assign({}, action, { 
                //      type: `∏${this.props.ns}:${action.type}`,
                "∏": [this.props.ns, ...(action["∏"] || [])] });
            this.getStore().dispatch(keyedAction);
            this.sagas.forEach(fn => fn(action));
            return keyedAction;
        }
        runSaga(saga, props) {
            const task = redux_saga_1.runSaga({
                dispatch: this.dispatch,
                getState: this.getState,
                subscribe: fn => {
                    this.sagas.add(fn);
                    return () => this.sagas.delete(fn);
                }
            }, saga, props);
            return task;
        }
        componentWillUnmount() {
            //    this.saga.cancel();
            //    this.context.projector.unregister(this.props.ns);
        }
        render() {
            /*
            return (
              <div style={{ margin: 5, padding: 5, border: "1px dotted pink" }}>
                <sub style={{ color: "pink" }}>{this.props.ns}</sub>
                {this.props.children}
              </div>
            );
            */
            return this.props.children;
        }
    }
    Projection.displayName = `Projection@${key}`;
    Projection.childContextTypes = {
        [key]: PropTypes.object
    };
    Projection.contextTypes = {
        store: PropTypes.object,
        [key]: PropTypes.object
    };
    Projection.saga = saga;
    // too many `any` here!
    Projection.connect = ((mstp, dp, mp, opts = {}) => {
        return react_redux_1.connect(mstp, dp, mp, Object.assign({}, opts, { storeKey: key }));
    });
    return Projection;
};
exports.KeyedProjection = KeyedProjection;
// hoistNonReactStatics has a bad ts.d so you can't import it as
// import hoistNonReactStatics from "hoist-non-react-statics";
// tslint:disable-next-line:no-var-requires
const hoistNonReactStatics = require("hoist-non-react-statics");
const project = (ns, C, saga, key = "store") => {
    const Pr = KeyedProjection(key);
    const Saga = saga ? Pr.saga(saga) : () => null;
    const Wrapped = (props) => (React.createElement(Pr, { ns: ns },
        React.createElement(Saga, null),
        React.createElement(C, Object.assign({}, props))));
    hoistNonReactStatics(Wrapped, C);
    return Wrapped;
};
exports.project = project;
//# sourceMappingURL=index.js.map